import { ChevronRight } from '@ifood/pomodoro-icons';
import React, { FC } from 'react';

import { Container } from './styles';

type PropTypes = {
  children: Array<React.ReactElement>;
};

export const Breadcrumbs: FC<PropTypes> = ({ children }) => <Container>{children}</Container>;

export const BreadcrumbIcon: FC = () => <ChevronRight width={16} height={16} />;
